// Delivery areas for SEO landing pages (/cake-delivery/:area)
export const DELIVERY_AREAS = [
  { slug: "sector-78-noida", name: "Sector 78, Noida", locality: "Noida" },
  { slug: "sector-79-noida", name: "Sector 79, Noida", locality: "Noida" },
  { slug: "sector-75-noida", name: "Sector 75, Noida", locality: "Noida" },
  { slug: "sector-76-noida", name: "Sector 76, Noida", locality: "Noida" },
  { slug: "sector-74-noida", name: "Sector 74, Noida", locality: "Noida" },
  { slug: "sector-100-noida", name: "Sector 100, Noida", locality: "Noida" },
  { slug: "sector-107-noida", name: "Sector 107, Noida", locality: "Noida" },
  { slug: "sector-128-noida", name: "Sector 128, Noida", locality: "Noida" },
  { slug: "sector-98-noida", name: "Sector 98, Noida", locality: "Noida" },
  { slug: "sector-45-noida", name: "Sector 45, Noida", locality: "Noida" },
  { slug: "sector-44-noida", name: "Sector 44, Noida", locality: "Noida" },
  { slug: "sector-46-noida", name: "Sector 46, Noida", locality: "Noida" },
  { slug: "sector-47-noida", name: "Sector 47, Noida", locality: "Noida" },
  { slug: "sector-49-noida", name: "Sector 49, Noida", locality: "Noida" },
  { slug: "sector-35-noida", name: "Sector 35, Noida", locality: "Noida" },
  { slug: "sector-32-noida", name: "Sector 32, Noida", locality: "Noida" },
  { slug: "sector-94-noida", name: "Sector 94, Noida", locality: "Noida" },
  { slug: "sector-126-noida", name: "Sector 126, Noida", locality: "Noida" },
  { slug: "sector-125-noida", name: "Sector 125, Noida", locality: "Noida" },
  { slug: "greater-noida-west", name: "Greater Noida West", locality: "Greater Noida" },
  { slug: "indirapuram", name: "Indirapuram, Ghaziabad", locality: "Ghaziabad" },
];

export const findArea = (slug) => DELIVERY_AREAS.find((a) => a.slug === slug);

// Festive / seasonal SEO landing pages (/occasions/:slug)
export const FESTIVE_OCCASIONS = [
  {
    slug: "christmas-plum-cakes-noida",
    name: "Christmas Plum Cakes",
    short: "Christmas",
    icon: "tree",
    h1: "Christmas Plum Cakes in Noida",
    title: "Christmas Plum Cakes in Noida — Order Online",
    description: "Order rich, traditional Christmas plum cakes online in Noida & Greater Noida. Loaded with dry fruits and warm spices, baked fresh with next-day delivery from Globaltreats.",
    blurb: "Make Christmas merrier with our rich, moist plum cakes — packed with dry fruits, nuts and warm festive spices. A cherished Globaltreats tradition, baked fresh and delivered across Noida & Greater Noida. Available in classic, chocolate and mawa varieties, with eggless options too.",
    tagline: "Rich dry-fruit plum cakes, freshly baked for the season.",
    category: "plum-cakes",
    accent: "#B23A2E",
    accentSoft: "#F7E4E1",
    badge: "Christmas Special",
    month: 12, day: 25,
    image: "/assets/plum-cake-dry-fruit.png",
  },
  {
    slug: "new-year-cakes-noida",
    name: "New Year Cakes",
    short: "New Year",
    icon: "sparkles",
    h1: "New Year Cakes in Noida",
    title: "New Year Cakes in Noida — Order Online",
    description: "Ring in the New Year with stunning designer cakes delivered online across Noida & Greater Noida. Party-ready flavours and celebration cakes, baked fresh with next-day delivery.",
    blurb: "Toast to new beginnings with a show-stopping New Year cake. From elegant designer creations to crowd-pleasing chocolate truffle, we bake fresh, party-ready cakes delivered right across Noida & Greater Noida — perfect for house parties and midnight celebrations.",
    tagline: "Party-ready celebration cakes to welcome the New Year.",
    category: "designer",
    accent: "#B8860B",
    accentSoft: "#FBF0D8",
    badge: "New Year Special",
    month: 1, day: 1,
    image: "https://images.unsplash.com/photo-1535141192574-5d4897c12636?w=800&q=80",
  },
  {
    slug: "valentines-day-cakes-noida",
    name: "Valentine's Day Cakes",
    short: "Valentine's",
    icon: "heart",
    h1: "Valentine's Day Cakes in Noida",
    title: "Valentine's Day Cakes in Noida — Order Online",
    description: "Say it with a romantic Valentine's Day cake delivered online in Noida & Greater Noida. Heart-shaped, chocolate and red velvet cakes baked fresh with next-day delivery from Globaltreats.",
    blurb: "Sweeten your celebration of love with a romantic Valentine's Day cake. Choose heart-shaped designs, decadent chocolate truffle or classic red velvet — beautifully hand-decorated and delivered fresh across Noida & Greater Noida. Add a personal message to make it unforgettable.",
    tagline: "Romantic heart-shaped & chocolate cakes for your special someone.",
    category: "anniversary",
    accent: "#D6336C",
    accentSoft: "#FBE3EC",
    badge: "Valentine's Special",
    month: 2, day: 14,
    image: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80",
  },
  {
    slug: "anniversary-cakes-noida",
    name: "Anniversary Cakes",
    short: "Anniversary",
    icon: "gift",
    h1: "Anniversary Cakes in Noida",
    title: "Anniversary Cakes in Noida — Order Online",
    description: "Celebrate your milestone with an elegant anniversary cake delivered online in Noida & Greater Noida. Designer, vintage and photo cakes baked fresh with next-day delivery from Globaltreats.",
    blurb: "Mark your special milestone with a beautifully crafted anniversary cake. From elegant vintage tiers to personalised photo cakes, our hand-decorated creations are baked fresh and delivered across Noida & Greater Noida — the perfect centrepiece for your celebration.",
    tagline: "Elegant, hand-decorated cakes for your special milestone.",
    category: "anniversary",
    accent: "#8E44AD",
    accentSoft: "#F1E6F7",
    badge: "Anniversary Special",
    image: "https://images.unsplash.com/photo-1535141192574-5d4897c12636?w=800&q=80",
  },
];

export const findOccasion = (slug) => FESTIVE_OCCASIONS.find((o) => o.slug === slug);

// Returns the soonest upcoming dated festive occasion (for the homepage banner).
export const getFeaturedOccasion = () => {
  const now = new Date();
  const dated = FESTIVE_OCCASIONS.filter((o) => o.month);
  let best = null;
  let bestDiff = Infinity;
  for (const o of dated) {
    let d = new Date(now.getFullYear(), o.month - 1, o.day);
    if (d < now) d = new Date(now.getFullYear() + 1, o.month - 1, o.day);
    const diff = d - now;
    if (diff < bestDiff) { bestDiff = diff; best = o; }
  }
  return best;
};

// FAQ content (also emitted as FAQPage structured data)
export const FAQS = [
  {
    q: "Which areas do you deliver cakes to in Noida & Greater Noida?",
    a: "We deliver freshly baked cakes across a wide radius of Sector 78, Noida — including Sectors 74, 75, 76, 79, 100, 107, 128, 45, 46, 47, 49, 32, 35, 94, 125, 126 and 98 — plus Greater Noida West and Indirapuram (Ghaziabad). Enter your pincode at checkout and we'll instantly confirm if you're in our delivery zone.",
  },
  {
    q: "How far in advance should I place my cake order?",
    a: "Every cake is baked fresh to order, so we deliver from the next day onwards, up to a month in advance. Simply choose your preferred delivery date and time slot at checkout.",
  },
  {
    q: "Do you offer eggless cakes?",
    a: "Yes! Every cake on our menu — from chocolate truffle to designer, photo and custom cakes — is available in a 100% eggless version at no extra cost. Just select the eggless option when ordering.",
  },
  {
    q: "Can I order a custom or photo cake?",
    a: "Absolutely. Use our Custom Cake form to share up to 5 reference images and tell us your flavour, size and design. We create bespoke and edible photo cakes for birthdays, anniversaries and corporate events.",
  },
  {
    q: "How much does cake delivery cost?",
    a: "Delivery is free on all orders above ₹999. For smaller orders, a small delivery fee is shown transparently at checkout before you pay.",
  },
  {
    q: "How is the price of a cake decided?",
    a: "Prices depend on the flavour, size (weight) and design complexity. Every product page shows the price clearly, and custom cakes are quoted based on your specific requirements.",
  },
  {
    q: "Can I cancel or change my order?",
    a: "Orders can be cancelled within 1 hour of placing them directly from your My Orders page. For any changes after that, message us on WhatsApp and we'll do our best to help.",
  },
  {
    q: "Are your cakes fresh and how do you keep them safe during delivery?",
    a: "Cakes are baked as close to your delivery date as possible, carefully boxed to protect the decoration, and handled with care in transit. You'll also receive email updates as your order is baked and dispatched.",
  },
];
